export default "__VITE_ASSET__DkYvVmuS__"